import { Helmet } from 'react-helmet';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Categories from '../components/Categories';
import '../styles/AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-wrapper">
      <Helmet>
        <title>About Us - Spardhaweb | MPSC Preparation Platform</title>
        <meta 
          name="description" 
          content="Learn more about Spardhaweb, a leading platform for MPSC preparation. Discover our mission, values, and the team behind our free test series and educational resources." 
        />
        <meta 
          name="keywords" 
          content="about Spardhaweb, MPSC preparation, MPSC test series team, educational resources, about us" 
        />
        
        {/* Open Graph Tags */}
        <meta property="og:title" content="About Us - Spardhaweb" />
        <meta 
          property="og:description" 
          content="Learn more about Spardhaweb, a leading platform for MPSC preparation. Discover our mission, values, and the team behind our free test series." 
        />
        <meta property="og:image" content={`${window.location.origin}/logo_.jpg`} />
        <meta property="og:url" content="https://spardhaweb.com/about-us" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Spardhaweb" />
        
        {/* Additional SEO */}
        <link rel="canonical" href="https://spardhaweb.com/about-us" />
      </Helmet>

      <Navbar />

      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="container">
          <div className="about-hero-content">
            <h1 className="about-hero-title">About Us</h1>
            <p className="about-hero-subtitle">
              Empowering MPSC Aspirants with Quality Education
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-content-section">
        <div className="container">
          {/* Welcome Section */}
          <div className="about-welcome">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="about-image-wrapper">
                  <img 
                    src="/logo_.jpg" 
                    alt="Spardhaweb Logo" 
                    className="about-main-image"
                  />
                  <div className="about-image-decoration"></div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-text-content">
                  <h2 className="about-section-title">
                    Welcome to <span className="brand-highlight">Spardhaweb</span>
                  </h2>
                  <p className="about-description">
                    <strong>Spardhaweb</strong> is a professional <strong>educational platform</strong> dedicated 
                    to helping MPSC aspirants achieve their dreams. We provide comprehensive study materials, 
                    daily quizzes, and current affairs updates in Marathi to ensure you're well-prepared for 
                    your exams.
                  </p>
                  <p className="about-description">
                    Our mission is to make quality education accessible to everyone. We are committed to 
                    providing you with reliable, engaging, and valuable content that enhances your preparation 
                    journey.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Mission & Vision */}
          <div className="about-mission-vision">
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="mission-card">
                  <div className="mission-icon">
                    <i className="fas fa-bullseye"></i>
                  </div>
                  <h3 className="mission-title">Our Mission</h3>
                  <p className="mission-text">
                    To empower MPSC aspirants with free, high-quality educational resources, 
                    daily practice tests, and comprehensive study materials that build confidence 
                    and ensure success in competitive examinations.
                  </p>
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <div className="mission-card">
                  <div className="mission-icon vision-icon">
                    <i className="fas fa-eye"></i>
                  </div>
                  <h3 className="mission-title">Our Vision</h3>
                  <p className="mission-text">
                    To become the most trusted and comprehensive platform for MPSC preparation, 
                    helping thousands of students achieve their career goals through accessible 
                    and innovative learning solutions.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* What We Offer */}
          <div className="about-features">
            <h2 className="about-section-title text-center mb-5">
              What We <span className="brand-highlight">Offer</span>
            </h2>
            <div className="row">
              <div className="col-md-4 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-clipboard-list"></i>
                  </div>
                  <h4 className="feature-title">Free Test Series</h4>
                  <p className="feature-description">
                    Access comprehensive test series covering all MPSC exam patterns with 
                    detailed solutions and performance analytics.
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-newspaper"></i>
                  </div>
                  <h4 className="feature-title">Daily Current Affairs</h4>
                  <p className="feature-description">
                    Stay updated with one-liner current affairs in Marathi, specially curated 
                    for MPSC examinations.
                  </p>
                </div>
              </div>
              <div className="col-md-4 mb-4">
                <div className="feature-card">
                  <div className="feature-icon">
                    <i className="fas fa-book-open"></i>
                  </div>
                  <h4 className="feature-title">Study Materials</h4>
                  <p className="feature-description">
                    Download quality study materials, notes, and e-books designed by experts 
                    to enhance your preparation.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Our Commitment */}
          <div className="about-commitment">
            <div className="commitment-card">
              <h2 className="about-section-title text-center mb-4">
                Our <span className="brand-highlight">Commitment</span>
              </h2>
              <p className="commitment-text">
                We strive to turn our passion for education into a thriving platform that serves 
                thousands of MPSC aspirants. Our focus is on reliability, quality content, and 
                continuous improvement based on your feedback.
              </p>
              <p className="commitment-text">
                We will keep posting valuable and knowledgeable information on our website for all 
                of you. Your love and support matter a lot to us, and we're committed to being your 
                trusted companion throughout your MPSC preparation journey.
              </p>
              <p className="commitment-text">
                We hope you enjoy our educational resources as much as we enjoy providing them to you. 
                Together, let's achieve success and make your dreams come true!
              </p>
            </div>
          </div>

          {/* Thank You Section */}
          <div className="about-thank-you">
            <div className="thank-you-card">
              <i className="fas fa-heart thank-you-icon"></i>
              <h3 className="thank-you-title">Thank You For Visiting Our Site</h3>
              <p className="thank-you-message">
                Your trust and support inspire us to deliver the best educational content. 
                We're here to help you succeed!
              </p>
              <p className="thank-you-wish">Have a great day! 🌟</p>
            </div>
          </div>
        </div>
      </section>

      <Categories />
      <Footer />
    </div>
  );
};

export default AboutUs;